export class CaptureProtectionPricingCardCommand {
	superhogUserId: string | null;
	productId: number;
	protectionLevelId: number;
	currencyId: number;
	pricingCardTypeId: number;
	approvedAmount: number;
	flaggedAmount: number;
	rejectedAmount: number;
	cancelledAmount: number;
	startDate?: string;
}
